export function Maintenance() {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h2>We’re updating the system…</h2>
      <p>Service will resume shortly.</p>
    </div>
  );
}
